if ( typeof window.renderHelperCart !== 'function' ) {
	window.renderHelperCart = (text) => {

		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
		const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

		const cartItems = document.getElementById('AjaxCartForm');
		cartItems.innerHTML = cartFormInnerHTML;
		cartItems.ajaxifyCartItems();

		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
		});
		document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
		});

		document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;

		return sectionInnerHTML;

	};
}

if ( window.KROWN && KROWN.functions && typeof KROWN.functions.dispatchStandardEvent !== 'function' ) {
	KROWN.functions.dispatchStandardEvent = (className, target, detail) => {
		const SE = window.Shopify && window.Shopify.StandardEvents;
		if ( ! SE || typeof SE[className] !== 'function' ) return;
		try {
			( target || document ).dispatchEvent(new SE[className](detail));
		} catch (error) {
			console.warn(`standard-events: ${className}`, error);
		}
	};
}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');
			const prefix = window.KT_PREFIX || '';

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector(`.${prefix}remove`);
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector(`.${prefix}qty`);
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;
			const prefix = window.KT_PREFIX || '';

			this.form.classList.add(`${prefix}processing`);
			if ( this.querySelector(`.${prefix}alert`) ) {
				this.querySelector(`.${prefix}alert`).remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
						KROWN.functions.eventDispatcher('krown:cart:error', {
							error: alert.textContent
						});

						KROWN.functions.dispatchStandardEvent('CartErrorEvent', this, {
							error: alert.textContent
						});
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					window.renderHelperCart(text);

					if ( alert !== null ) {
						this.form.prepend(alert);
					}

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

					const updatedItem = this.querySelector(`[data-js-cart-item][data-line="${item.dataset.line}"]`);
					if ( updatedItem ) {
						KROWN.functions.eventDispatcher('krown:cart:update', {
							itemKey: updatedItem.dataset.id,
							itemQty: updatedItem.dataset.qty,
							itemVariantId: updatedItem.dataset.variant,
							itemProductId: updatedItem.dataset.productId
						});
					}

					if ( alert === null ) {
						KROWN.functions.dispatchStandardEvent('CartLinesUpdateEvent', this, {
							action: newQty === 0 ? 'remove' : 'update',
							context: 'cart',
							lines: [{
								id: item.dataset.id,
								quantity: newQty
							}],
							promise: Promise.resolve({ cart: null })
						});
					}

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add(`${prefix}alert`, `${prefix}alert--error`);
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove(`${prefix}processing`);
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this._prefix = window.KT_PREFIX || '';
			this.querySelector(`.${this._prefix}qty-minus`).addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector(`.${this._prefix}qty-plus`).addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector(`.${this._prefix}qty`).value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}


if ( ! window.refreshCart ) {

	window.refreshCart = (openDrawer = true) => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			window.renderHelperCart(text);

			if ( document.querySelector('[data-js-site-cart-sidebar]') && openDrawer === true ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, {
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body
						}).then(() => {
							KROWN.functions.dispatchStandardEvent('CartNoteUpdateEvent', this, {
								context: 'cart',
								note: event.target.value,
								promise: Promise.resolve({ cart: null })
							});
						});
		  		}, 300)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {

				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');
				this._prefix = window.KT_PREFIX || '';
				this.#loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add(`${this._prefix}processing`);
						if (this.discountCodes) {
							this.discountCodes.classList.add(`${this._prefix}processing`);
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const entered = this.input.value.trim();
						const allDiscounts = [...existingDiscounts, entered];

						// TUFF PETS: apply via the Storefront API so Shopify tells us WHY a code failed.
						// Falls back to the theme's original AJAX behaviour if that call fails for any reason.
						this.#applyWithReasons(allDiscounts, entered).catch(error => {
							console.log(`Discount reasons unavailable, using fallback: ${error}`);
							this.#legacyApply(allDiscounts);
						});

					}

				});

			}

			// Original theme behaviour (generic error only) - kept as a fallback.
			#legacyApply(allDiscounts){
				const discountString = allDiscounts.join(',');
				const body = JSON.stringify({ discount: discountString });

				fetch(`${KROWN.settings.routes.cart_update_url}`, { 
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body 
				})
					.then(response => response.json())
					.then(response => {
						const discountCodes = response.discount_codes;
						const inputValue = this.input.value;
						const matchingCode = discountCodes.find(code => 
							code.code === inputValue
						);

						if (matchingCode) {
							if (matchingCode.applicable) {
								this.#handleSuccess();
							} else {
								this.#handleError();
							}
						} else {
							this.#handleError();
						}
					})
					.catch(error => {
						this.#handleError();
						console.log(`Error: ${error}`);
					})

			}

			async #applyWithReasons(allDiscounts, entered){
				const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
				const cart = await fetch(`${root}cart.js`).then(r => r.json());
				const response = await fetch(`${root}api/2026-07/graphql.json`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						query: `mutation TuffDiscount($id: ID!, $codes: [String!]!) {
							cartDiscountCodesUpdate(cartId: $id, discountCodes: $codes) {
								cart { discountCodes { code applicable } }
								userErrors { code message }
								warnings { code message }
							}
						}`,
						variables: { id: `gid://shopify/Cart/${cart.token}`, codes: allDiscounts }
					})
				}).then(r => r.json());

				const result = response && response.data && response.data.cartDiscountCodesUpdate;
				if ( ! result || ! result.cart || (result.userErrors && result.userErrors.length) ) {
					throw new Error(JSON.stringify((response && response.errors) || (result && result.userErrors) || 'no result'));
				}

				const same = (a, b) => String(a).toUpperCase() === String(b).toUpperCase();
				const mentions = (w, code) => String(w.message || '').toUpperCase().includes(String(code).toUpperCase());
				const codes = result.cart.discountCodes || [];
				const warnings = result.warnings || [];
				const mine = codes.find(c => same(c.code, entered));

				if ( mine && mine.applicable ) {
					// New code worked - but did it knock out a code that was already applied?
					const bumped = codes.filter(c => !c.applicable && !same(c.code, entered)).map(c => c.code);
					const notice = bumped.length
						? this.#message('COMBINE_NOTICE', { code: entered, others: bumped.join(', ') })
						: '';
					this.#handleSuccess(notice);
					return;
				}

				const otherCodes = allDiscounts.filter(c => !same(c, entered));
				const warning =
					warnings.find(w => mentions(w, entered)) ||
					warnings.find(w => !otherCodes.some(c => mentions(w, c))) ||
					null;
				this.#handleError(warning ? this.#message(warning.code, { code: entered, fallback: warning.message }) : null);
			}

			// Plain-English reasons. These come from Shopify's own evaluation of the code,
			// so they never drift out of sync with the discount settings in the admin.
			#message(reason, { code = '', others = '', fallback = '' } = {}){
				const esc = t => String(t).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
				const c = `<span style="font-weight: 600;">${esc(code)}</span>`;
				const messages = {
					DISCOUNT_NOT_FOUND: `We don't recognise ${c}. Please check the spelling and try again.`,
					DISCOUNT_CURRENTLY_INACTIVE: `${c} isn't active right now - it may have expired or not started yet.`,
					DISCOUNT_CUSTOMER_NOT_ELIGIBLE: `Your account isn't eligible for ${c}. Some offers are only available to first-time customers.`,
					DISCOUNT_ELIGIBLE_CUSTOMER_MISSING: `${c} is only available to eligible customers. Please log in, or enter your email at checkout to check.`,
					DISCOUNT_CUSTOMER_USAGE_LIMIT_REACHED: `You've already used ${c}.`,
					DISCOUNT_USAGE_LIMIT_REACHED: `${c} has already been used the maximum number of times.`,
					DISCOUNT_NO_ENTITLED_LINE_ITEMS: `${c} doesn't apply to the items in your cart.`,
					DISCOUNT_NO_ENTITLED_SHIPPING_LINES: `${c} doesn't apply to the shipping for this order.`,
					DISCOUNT_PURCHASE_NOT_IN_RANGE: `Your cart total doesn't meet the spend requirement for ${c}.`,
					DISCOUNT_QUANTITY_NOT_IN_RANGE: `Your cart doesn't have the number of items needed for ${c}.`,
					DISCOUNT_INCOMPATIBLE_PURCHASE_TYPE: `${c} can't be used with this type of purchase (for example, subscriptions).`,
					DISCOUNT_CODE_NOT_HONOURED: `${c} can't be combined with the discount already in your cart.`,
					COMBINE_NOTICE: `${c} has been applied. ${esc(others)} can't be used alongside it, so it no longer applies.`
				};
				const text = messages[reason] || (fallback ? esc(fallback) : null);
				const style = reason === 'COMBINE_NOTICE' ? 'alert--note' : 'alert--error';
				return text ? `<span class="alert ${style} text-size--small"><span>${text}</span></span>` : null;
			}

			#handleSuccess(notice = ''){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = window.renderHelperCart(text);

						this.cartSubtotal.classList.remove(`${this._prefix}processing`);
						this.cartDiscountError.innerHTML = notice || '';
						this.input.value = '';
						// On the cart page the re-render above replaces this element, so put any notice on the fresh copy.
						if ( notice && ! this.isConnected ) {
							document.querySelectorAll('#AjaxCartSubtotal [data-js-discount-error]').forEach(el => { el.innerHTML = notice; });
						}

						const sectionDiscountCodes = sectionInnerHTML.querySelector('[data-js-discount-codes]');
						if ( this.discountCodes && sectionDiscountCodes ) {
							this.discountCodes.innerHTML = sectionDiscountCodes.innerHTML;
							this.discountCodes.classList.remove(`${this._prefix}processing`);
							this.#loadDiscountButtons();
						}

						const appliedDiscountCodes = sectionDiscountCodes
							? Array.from(sectionDiscountCodes.querySelectorAll('[data-js-discount]')).map(el => ({ code: el.dataset.jsDiscount }))
							: [];
						KROWN.functions.dispatchStandardEvent('CartDiscountUpdateEvent', this, {
							discountCodes: appliedDiscountCodes,
							promise: Promise.resolve({ cart: null })
						});
					})
					.catch(() => this.#handleError())
			}

			#loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains(`${this._prefix}enabled`) ) {
						elm.classList.add(`${this._prefix}enabled`);
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add(`${this._prefix}processing`);
							if (this.discountCodes) {
								this.discountCodes.classList.add(`${this._prefix}processing`);
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.#handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			#handleError(message = null){
				this.cartSubtotal.classList.remove(`${this._prefix}processing`);
				if (this.discountCodes) {
					this.discountCodes.classList.remove(`${this._prefix}processing`);
				}
				this.cartDiscountError.innerHTML = message || window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}